import * as React from 'react';

import { Col } from 'common/components';
import { useFetchEventProcedureSteps } from 'security-app/hooks/useEventProceduresAPI';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';
import type { EntityBase } from 'components/common/EntityDataTable/types';
import QueryHelper from 'components/common/QueryHelper';
import PaginatedEntityTable from 'components/common/PaginatedEntityTable';

import { listElements } from './constants';
import { columnRenderers } from './column-renderers';
import useTableElements from './use-table-elements';

type Props = {
  selectedSteps: Array<EventProcedureStepAPIType>;
};

function EventProcedureStepLibraryList({ selectedSteps }: Props) {
  const { eventProcedureStepsEntitiesKeyFn, searchEventProcedureSteps } = useFetchEventProcedureSteps();
  const { expandedSections, bulkSelection } = useTableElements(selectedSteps);

  return (
    <Col $align="center">
      <PaginatedEntityTable<EntityBase & EventProcedureStepAPIType>
        humanName="Event Procedures Step"
        entityActions={null}
        columnsOrder={listElements.columnOrder}
        queryHelpComponent={<QueryHelper entityName="Event Procedure Step" />}
        tableLayout={listElements.defaultLayout}
        fetchEntities={searchEventProcedureSteps}
        keyFn={eventProcedureStepsEntitiesKeyFn}
        actionsCellWidth={0}
        entityAttributesAreCamelCase={false}
        columnRenderers={columnRenderers}
        expandedSectionsRenderer={expandedSections}
        bulkSelection={bulkSelection}
        withoutURLParams
      />
    </Col>
  );
}

export default EventProcedureStepLibraryList;
